var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 89,
    viewBox: "0 0 91 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.066 29.622v16.79c0 8.74-2.76 15.85-11.43 15.85s-11.43-7.11-11.43-15.85V14.325c.033-.379.004-.76.004-1.149 0-.192-.006-.384-.014-.574h.002c0-.018-.002-.035-.003-.053-.009-.169-.02-.337-.035-.503l-.008-.107C25.538 5.243 19.998 0 13.192 0c-.448 0-.891.023-1.329.068C5.43.654.356 5.938.008 12.492c-.003.037-.007.074-.008.11v33.81C0 69.718 14.515 88.68 37.635 88.68c22.83 0 37.16-18.487 37.628-41.388v-17.67H49.066",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.207)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m78.476 3.506-5.97-.005-23.471 26.254h29.649c6.459-.301 11.403-6.575 11.403-13.462S84.934 3.806 78.476 3.506z",
    stroke: "#FA8600",
    strokeWidth: 0.5,
    fill: "#EB8B2D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#4AB9BA",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.513 29.505v15.26L48.07 29.506h27.442z",
    stroke: "#1C506F",
    strokeWidth: 0.5,
    fill: "#1C506F",
    fillRule: "nonzero",
    mask: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPlain);
export default __webpack_public_path__ + "static/media/Logo_plain.4c1ac81de06e5bf5bb696421d63b2af2.svg";
export { ForwardRef as ReactComponent };